import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { colorPalette } from 'stylesheet';

import { lateralMenuStyle } from '../LateralMenu.style';

export const LateralMenuLinkContainer = styled(NavLink)`
  ${lateralMenuStyle.itemContainer};
  position: relative;
  &.is-active {
    color: ${colorPalette.white};
    &.disabled {
      pointer-events: none;
    }
  }
`;

export const LateralMenuLinkLabel = styled.p`
  ${lateralMenuStyle.itemLabel}
`;
